import { EvalType } from 'view/components/teacher/assignment/forms/Evaluation';

export default class EvaluationSubmission {
  public readonly id;
  public evaluation: string;
  public baseline: number;
  public override_default: boolean;
  public type: EvalType;
  public user: string;
  public completion_time: number;
  public lexile_reading: number;
  public wida_listening: number;
  public wida_reading: number;
  public wida_speaking: number;
  public wida_writing: number;
  public round: number;
  public rounds: number;
  public questions_per_round: number;
  public date_completed?: string;
  public classroom?: string;

  constructor(
    id: string,
    evaluation: string,
    baseline: number,
    override_default: boolean,
    type: EvalType,
    user: string,
    completion_time: number,
    lexile_reading: number,
    wida_listening: number,
    wida_reading: number,
    wida_speaking: number,
    wida_writing: number,
    round: number,
    rounds: number,
    questions_per_round: number,
    date_completed?: string,
    classroom?: string,
  ) {
    this.id = id;
    this.evaluation = evaluation;
    this.baseline = baseline;
    this.override_default = override_default;
    this.type = type;
    this.user = user;
    this.completion_time = completion_time;

    this.lexile_reading = lexile_reading;
    this.wida_reading = wida_reading;
    this.wida_listening = wida_listening;
    this.wida_speaking = wida_speaking;
    this.wida_writing = wida_writing;

    this.round = round;
    this.rounds = rounds;
    this.questions_per_round = questions_per_round;

    this.date_completed = date_completed;
    this.classroom = classroom;
  }

  static fromEvaluationSubmission(submission: EvaluationSubmission) {
    return new EvaluationSubmission(
      submission.id,
      submission.evaluation,
      submission.baseline,
      submission.override_default,
      submission.type,
      submission.user,
      submission.completion_time,
      submission.lexile_reading,
      submission.wida_reading,
      submission.wida_listening,
      submission.wida_speaking,
      submission.wida_writing,
      submission.round,
      submission.rounds,
      submission.questions_per_round,
      submission.date_completed,
      submission.classroom,
    );
  }

  static fromServerEvaluationSubmission(
    submission: Record<string, any>,
  ): EvaluationSubmission {
    return new EvaluationSubmission(
      submission.submission['id'],
      submission.submission['evaluation'],
      submission.evaluation['baseline'],
      submission.evaluation['override_default'],
      submission.evaluation['type'],
      submission.submission['user'],
      submission.submission['completion_time'],
      submission.submission['lexile_reading'],
      submission.submission['wida_reading'],
      submission.submission['wida_listening'],
      submission.submission['wida_speaking'],
      submission.submission['wida_writing'],
      submission.submission['round'],
      submission.evaluation['rounds'],
      submission.evaluation['questions_per_round'],
      submission.submission['date_completed'],
      submission.evaluation['classroom'],
    );
  }

  public toJSON(): Record<string, any> {
    return {
      id: this.id,
      evaluation: this.evaluation,
      baseline: this.baseline,
      override_default: this.override_default,
      type: this.type,
      user: this.user,
      completion_time: this.completion_time,
      lexile_reading: this.lexile_reading,
      wida_reading: this.wida_reading,
      wida_listening: this.wida_listening,
      wida_speaking: this.wida_speaking,
      wida_writing: this.wida_writing,
      round: this.round,
      rounds: this.rounds,
      questions_per_round: this.questions_per_round,
      date_completed: this.date_completed,
      classroom: this.classroom,
    };
  }
}

/*
evaluation_submission = models.ForeignKey(
        EvaluationSubmission, on_delete=models.CASCADE
    )
    question = models.ForeignKey(EvaluationQuestion, on_delete=models.CASCADE)
    response = models.TextField(default="", max_length=1500, blank=True)
    grade = models.FloatField(default=0)
    completed = models.BooleanField(default=False)
    choice = models.ForeignKey(
        EvaluationMultiChoiceOption, on_delete=models.SET_NULL, null=True, blank=True
    )
*/
